<template>
  <v-col :md="feld.breite" cols="12" sm="6" class="py-1 px-1">
    <span v-if="feld.type === 'String'">
      <v-text-field
        hide-details="auto"
        @change="sendDataBack"
        dense
        outlined
        :label="feld.label"
        v-model="value"
      ></v-text-field>
    </span>
    <span v-if="feld.type === 'Select'">
      <v-select
        hide-details="auto"
        @change="sendDataBack"
        dense
        outlined
        :label="feld.label"
        v-model="value"
        :items="feld.options"
      ></v-select>
    </span>
    <span v-if="feld.type === 'Date'">
      <v-menu
        :ref="value"
        v-model="menuFeldVar"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            hide-details="auto"
            dense
            outlined
            :value="formatDate"
            :label="feld.label"
            readonly
            clearable
            @click:clear="clearValue()"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          @change="sendDataBack"
          prev-icon="keyboard_arrow_left"
          next-icon="keyboard_arrow_right"
          v-model="value"
          locale="de-de"
          first-day-of-week="1"
          @input="menuFeldVar = false"
          no-title
          scrollable
        >
        </v-date-picker>
      </v-menu>
    </span>
    <span v-if="feld.type === 'Anrede'">
      <v-select
        hide-details="auto"
        @change="sendDataBack"
        dense
        outlined
        :label="feld.label"
        v-model="value"
        :items="itemsAnrede"
      ></v-select>
    </span>
    <span v-if="feld.type === 'Briefanrede'">
      <v-select
        hide-details="auto"
        @change="sendDataBack"
        dense
        outlined
        :label="feld.label"
        v-model="value"
        :items="itemsBriefanrede"
      ></v-select>
    </span>
    <span v-if="feld.type === 'Status'">
      <v-select
        hide-details="auto"
        @change="sendDataBack"
        dense
        outlined
        :label="feld.label"
        v-model="value"
        :items="itemsStatus"
      ></v-select>
    </span>
    <span v-if="feld.type === 'Telefon'">
      <v-text-field
        hide-details="auto"
        @input="formatPhoneNumber"
        :rules="[rules.telefonnummer]"
        @change="sendDataBack"
        dense
        outlined
        :label="feld.label"
        v-model="value"
      ></v-text-field>
    </span>
    <span v-if="feld.type === 'Leibvater'">
      <v-autocomplete
        hide-details="auto"
        @change="sendDataBack"
        dense
        outlined
        :label="feld.label"
        clearable
        clear-icon="close"
        v-model="value"
        :items="$selectLeibvater()"
      ></v-autocomplete>
    </span>
    <span v-if="feld.type === 'Verbindung' || feld.type === 'Verbindungen'">
      <v-combobox
        hide-details="auto"
        @change="sendDataBack"
        dense
        outlined
        :multiple="feld.type === 'Verbindungen'"
        v-model="value"
        :items="selectVerbindung"
        :label="feld.label"
        clearable
      ></v-combobox>
    </span>
    <span v-if="feld.type === 'Gruppen'">
      <v-select
        hide-details="auto"
        multiple
        small-chips
        deletable-chips
        @change="sendDataBack"
        dense
        outlined
        :label="feld.label"
        v-model="value"
        :items="itemsGruppen"
      ></v-select>
    </span>
    <span v-if="feld.type === 'Zirkel'">
      <v-select
        clearable
        hide-details="auto"
        @change="sendDataBack"
        dense
        outlined
        :label="feld.label"
        v-model="value"
        :items="itemsZirkel"
      ></v-select>
    </span>
    <span v-if="feld.type === 'money'">
      <v-text-field
        hide-details="auto"
        @change="sendDataBack"
        dense
        outlined
        :label="feld.label"
        v-model="value"
        @input="formatMoney"
        :rules="[rules.required, rules.geld]"
      ></v-text-field>
    </span>
  </v-col>
</template>

<script>
  export default {
    props: ["feld", "value"],
    data() {
      return {
        loading: false,
        menuFeldVar: false,
        date: "",
        selectVerbindung: [
          "V.K.Th. Burgundia im Albertinum",
          "AV Alania Stuttgart",
          "AV Alsatia Münster",
          "AV Cheruscia Münster",
          "AV Cheruskia Tübingen",
          "AV Frisia Hannover",
          "AV Glückauf-Salia Clausthal-Zellerfeld",
          "AV Guestfalia Tübingen",
          "AV Hansea (Berlin) Köln",
          "AV Palatia Göttingen",
          "AV Rheinstein Köln",
          "AV Rheno-Guestfalia Kiel",
          "AV Salia-Silesia Gleiwitz",
          "AV Silesia (Halle, Bonn) Bochum",
          "AV Sparrenberg Bielefeld",
          "AV Suebo-Danubia Ulm",
          "AV Tuisconia (Königsberg, Bonn) Landshut",
          "AV Widukind Osnabrück",
          "AV Zollern Münster",
          "CV-Verbindung Rheno-Palatia (Breslau) Mainz",
          "FAV Rheno-Guestfalia (Hann. Münden) Göttingen",
          "KAV Capitolina Rom",
          "KAV Suevia Berlin",
          "KDStV Adolphiana Fulda",
          "KDStV Aenania München",
          "KDStV Agilolfia Freising",
          "KDStV Alania Bonn",
          "KDStV Alcimonia Eichstätt",
          "KDStV Alemannia Greifswald und Münster",
          "KDStV Algovia Augsburg",
          "KDStV Angrivaria (Sarstedt, Hannover) Dortmund",
          "KDStV Arminia Freiburg im Breisgau",
          "KDStV Arminia Heidelberg",
          "KDStV Ascania Bonn",
          "KDStV Asgard (Düsseldorf) Köln",
          "KDStV Aureo-Danubia Ingolstadt",
          "KDStV Badenia (Straßburg) Frankfurt am Main",
          "KDStV Baltia (Danzig) Aachen",
          "KDStV Bavaria Berlin",
          "KDStV Bavaria Bonn",
          "KDStV Bergisch-Thuringia Wuppertal",
          "KDStV Bergland (Freiberg) Aachen",
          "KDStV Bodensee Konstanz",
          "KDStV Borusso-Saxonia Berlin",
          "KDStV Borusso-Westfalia Bonn",
          "KDStV Burgundia (Leipzig) Düsseldorf",
          "KDStV Burgundia München",
          "KDStV Carolingia Hohenheim",
          "KDStV Carolus Magnus Saarbrücken",
          "KDStV Cheruscia Würzburg",
          "KDStV Churpfalz Mannheim",
          "KDStV Chursachsen Dresden",
          "KDStV Churtrier Trier",
          "KDStV Elbmark (Tetschen-Liebwerd) Duisburg",
          "KDStV Falkenstein Freiburg im Breisgau",
          "KDStV Ferdinandea (Prag) Heidelberg",
          "KDStV Franco-Raetia Würzburg",
          "KDStV Franconia Aachen",
          "KDStV Frankonia (Czernowitz) Erlangen",
          "KDStV Fredericia Bamberg",
          "KDStV Germania Leipzig",
          "KDStV Gothia Erlangen",
          "KDStV Gothia Würzburg",
          "KDStV Greiffenstein (Breslau) Frankfurt",
          "KDStV Guestfalo-Silesia Paderborn",
          "KDStV Hasso-Nassovia Frankfurt am Main",
          "KDStV Hercynia Freiburg im Breisgau",
          "KDStV Hohenstaufen Freiburg im Breisgau",
          "KDStV Kaiserpfalz Aachen",
          "KDStV Langobardia (München) Bayreuth",
          "KDStV Makaria (Berlin) Aachen",
          "KDStV Marchia (Breslau) Aachen",
          "KDStV Markomannia Würzburg",
          "KDStV Merowingia Kaiserslautern",
          "KDStV Moenania München",
          "KDStV Moeno-Franconia Frankfurt am Main",
          "KDStV Nassovia Darmstadt",
          "KDStV Nibelungia (Brünn) Darmstadt",
          "KDStV Niedersachsen Braunschweig",
          "KDStV Norbertina Magdeburg",
          "KDStV Nordgau (Prag, Stuttgart) Koblenz",
          "KDStV Nordmark (Rostock, Karlsruhe) Essen",
          "KDStV Normannia Karlsruhe",
          "KDStV Novesia Bonn",
          "KDStV Oeno-Danubia Passau",
          "KDStV Ostmark Nürnberg",
          "KDStV Palatia Marburg",
          "KDStV Palatina Amberg/Weiden",
          "KDStV Radaspona (Regensburg) München",
          "KDStV Rappoltstein (Straßburg) Köln",
          "KDStV Rheinland Köln",
          "KDStV Rheinpfalz Darmstadt",
          "KDStV Rhenania-Moguntia Mainz",
          "KDStV Rheno-Baltia Köln",
          "KDStV Rheno-Franconia München",
          "KDStV Rheno-Saxonia (Köthen) Halle",
          "KDStV Ripuaria Aachen",
          "KDStV Ripuaria Bonn",
          "KDStV Ripuaria Freiburg im Breisgau",
          "KDStV Rupertia Regensburg",
          "KDStV Saarland (Saarbrücken) Jena",
          "KDStV Sauerlandia Münster",
          "KDStV Saxo-Silesia Hannover",
          "KDStV Saxo-Thuringia (Dresden, Aachen) Bochum",
          "KDStV Schwarzwald Karlsruhe",
          "KDStV Seraphina Lippstadt",
          "KDStV Staufia Bonn",
          "KDStV Sugambria (Jena) Göttingen",
          "KDStV Teuto-Rhenania Hannover",
          "KDStV Teutonia Freiburg im Üechtland",
          "KDStV Thuringia Würzburg",
          "KDStV Trifels München",
          "KDStV Tuiskonia München",
          "KDStV Vandalia (Prag) München",
          "KDStV Vasgovia Landau",
          "KDStV Vindelicia München",
          "KDStV Welfia Weingarten",
          "KDStV Wiking Hamburg",
          "KDStV Wildenstein Freiburg im Breisgau",
          "KDStV Winfridia (Breslau) Münster",
          "KStV Thuringia Coburg",
          "KTV Visurgis Bremen",
          "VKDSt Hasso-Rhenania Gießen",
          "VKDSt Hasso-Rhenania Mainz",
          "VKDSt Rhenania Marburg",
          "VKDSt Saxonia Münster",
        ],
        itemsAnrede: ["Herr", "Frau", "Familie"],
        itemsBriefanrede: [
          "Lieber Bundesbruder",
          "Sehr geehrter Cartellbruder",
          "Sehr geehrter Farbenbruder",
          "Sehr geehrter Herr",
          "Sehr geehrte Frau",
          "Sehr geehrte Damen und Herren",
          "Liebe",
          "Lieber",
        ],
        itemsZirkel: [
          "Aachen",
          "Berlin",
          "Bonn/Köln",
          "Düsseldorf/Neuss",
          "Essen",
          "Koblenz",
          "München",
          "Niederrhein",
        ],
        itemsGruppen: [
          "HBV-Mitglieder",
          "HBV-Beirat",
          "Vorstände",
          "AHV-Vorstand",
          "HBV-Vorstand",
          "Aktive Chargen",
          "80er",
        ],
        rules: {
          required: (value) => !!value || false,
          email: (value) => {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return value === "" || pattern.test(value) || "Flasches E-Mail-Format";
          },
          telefonnummer: (value) => {
            const pattern = /^\+([0-9]){2}[ ][1-9]([0-9]){2}[0-9]?[ ]([0-9]?){12}$/g;
            return (
              value === "" ||
              pattern.test(value) ||
              "Flasches Telefonnummern-Format. Es muss +49 123 456789123 entsprechen"
            );
          },
          geld: (value) => {
            const pattern = /^[0-9]([0-9]?){10}([.]([0-9]?){2})?$/g;
            return value === "" || pattern.test(value) || "Flasches Format. Es muss 13.45 entsprechen";
          },
        },
      };
    },
    computed: {
      formatDate() {
        if (this.feld.type !== "Date") return null;
        if (!this.value) return null;
        return new Date(this.value).toLocaleString(["de-de"], { month: "long", day: "numeric", year: "numeric" });
      },
      itemsStatus() {
        let status = [];
        this.$store.getters["einstellungen/einstellung"]("mitgliederstatus").status.forEach((item) => {
          status.push(item.status);
        });
        return status;
      },
    },
    methods: {
      clearValue() {
        this.value = "";
        this.sendDataBack();
      },
      formatMoney() {
        let moneyValue = this.value.trim().replace(/\s+/g, "");
        moneyValue = moneyValue.replace(",", ".").replace(/[^0-9.]/g, "");
        // Stelle sicher, dass es nur einen Punkt gibt und keine weiteren Punkte nach der ersten Dezimalstelle
        const parts = moneyValue.split(".");
        if (parts.length > 2) {
          moneyValue = parts[0] + "." + parts.slice(1).join("");
        }
        // Wenn es Dezimalstellen gibt, begrenze auf zwei Nachkommastellen
        if (moneyValue.includes(".")) {
          const [integerPart, decimalPart] = moneyValue.split(".");
          moneyValue = integerPart + "." + decimalPart.substring(0, 2);
        }
        this.value = moneyValue; // Aktualisiere das v-model mit dem formatierten Geldbetrag
      },
      formatPhoneNumber() {
        let phoneNumber = this.value.trim().replace(/\s+/g, ""); // Entferne führende und nachfolgende Leerzeichen und ersetze doppelte Leerzeichen durch ein Leerzeichen
        if (phoneNumber.startsWith("+")) {
          // Überprüfe, ob die Telefonnummer mit "+" beginnt
          phoneNumber = "+" + phoneNumber.substring(1).replace(/[^0-9]/g, ""); // Entferne alle Nicht-Ziffern-Zeichen
        } else if (phoneNumber.startsWith("0")) {
          // Überprüfe, ob die Telefonnummer mit "0" beginnt
          phoneNumber = "+49" + phoneNumber.substring(1).replace(/[^0-9]/g, ""); // Ersetze "0" am Anfang durch "+49" und entferne alle Nicht-Ziffern-Zeichen
        }
        if (phoneNumber.length >= 3) {
          // Füge Leerzeichen nach der Ländervorwahl hinzu
          phoneNumber = phoneNumber.replace(/(\d{2})(\d{3})(\d{1,})/, "$1 $2 $3");
        }
        this.value = phoneNumber; // Aktualisiere das v-model mit der formatierten Telefonnummer
      },
      sendDataBack() {
        this.$emit("dataChange", this.value, this.feld);
      },
    },
  };
</script>

<style scoped></style>




// WEBPACK FOOTER //
// kontaktfield.vue?4450ddc1